import React from 'react';
interface Props {
  fillColor?: string;
}
function OpticalIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none">
      <g clipPath="url(#clip0_851_3407)">
        <path
          d="M8.99922 2.75C6.96172 2.75 5.28672 3.675 4.00234 4.86562C2.79922 5.98438 1.96797 7.3125 1.54297 8.25C1.96797 9.1875 2.79922 10.5156 3.99922 11.6344C5.28672 12.825 6.96172 13.75 8.99922 13.75C11.0367 13.75 12.7117 12.825 13.9961 11.6344C15.1992 10.5156 16.0305 9.1875 16.4555 8.25C16.0305 7.3125 15.1992 5.98438 13.9992 4.86562C12.7117 3.675 11.0367 2.75 8.99922 2.75ZM2.98047 3.76875C4.45234 2.4 6.47422 1.25 8.99922 1.25C11.5242 1.25 13.5461 2.4 15.018 3.76875C16.4805 5.12812 17.4586 6.75 17.9242 7.86562C18.0273 8.1125 18.0273 8.3875 17.9242 8.63437C17.4586 9.75 16.4805 11.375 15.018 12.7312C13.5461 14.1 11.5242 15.25 8.99922 15.25C6.47422 15.25 4.45234 14.1 2.98047 12.7312C1.51797 11.375 0.539844 9.75 0.0773437 8.63437C-0.0257813 8.3875 -0.0257813 8.1125 0.0773437 7.86562C0.539844 6.75 1.51797 5.125 2.98047 3.76875ZM8.99922 10.75C10.3805 10.75 11.4992 9.63125 11.4992 8.25C11.4992 6.86875 10.3805 5.75 8.99922 5.75C8.97734 5.75 8.95859 5.75 8.93672 5.75C8.97734 5.90938 8.99922 6.07812 8.99922 6.25C8.99922 7.35313 8.10234 8.25 6.99922 8.25C6.82734 8.25 6.65859 8.22813 6.49922 8.1875C6.49922 8.20937 6.49922 8.22813 6.49922 8.25C6.49922 9.63125 7.61797 10.75 8.99922 10.75ZM8.99922 4.25C10.0601 4.25 11.0775 4.67143 11.8276 5.42157C12.5778 6.17172 12.9992 7.18913 12.9992 8.25C12.9992 9.31087 12.5778 10.3283 11.8276 11.0784C11.0775 11.8286 10.0601 12.25 8.99922 12.25C7.93835 12.25 6.92094 11.8286 6.17079 11.0784C5.42065 10.3283 4.99922 9.31087 4.99922 8.25C4.99922 7.18913 5.42065 6.17172 6.17079 5.42157C6.92094 4.67143 7.93835 4.25 8.99922 4.25Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3407">
          <rect
            width="18"
            height="16"
            fill="white"
            transform="translate(0 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OpticalIcon;
